import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp } from 'dripsy';
import { useContext, useEffect } from 'react';
import Svg, { G, Rect } from 'react-native-svg';
import { AxisX } from '../axis/AxisX';
import { AxisY } from '../axis/AxisY';
import { AxisItem, useAxis } from '../axis/useAxis.hook';
import { Bars } from './Bars';
import { BarChartMargin } from './type';

interface BarChartProps {
  data: Array<AxisItem>;
  width: number;
  height: number;
  margin?: BarChartMargin;
  xTitle?: string;
  yTitle?: string;
}

export const BarChart: React.FC<BarChartProps> = ({
  data,
  width,
  height,
  margin = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  xTitle,
  yTitle
}) => {
  const axis = useAxis({ data, width, height, margin });
  const layout = useContext(LayoutContext);
  return (
    <Svg width={width} height={height} style={{ overflow: layout.isMobile ? 'hidden' : 'visible' }}>
      <G y={axis.graphHeight} transform={`translate(${margin.left * 2}, ${margin.top})`}>
        {/* bottom axis */}
        <AxisX xScale={axis.xScale} labels={data.map((item) => item.label)} width={width} height={height} margin={margin} xTitle={xTitle} />
        <AxisY
          yScale={axis.yScale}
          width={axis.graphWidth}
          height={axis.graphHeight}
          values={data.map((item) => item.value)}
          margin={margin}
          yTitle={yTitle}
        />

        {/* bars */}
        {data.length > 0 && (
          <Bars
            xScale={axis.xScale}
            yScale={axis.yScale}
            data={data}
            width={axis.graphWidth}
            height={axis.graphHeight}
            margin={margin}
            barWidth={data.length > 10 ? 15 : 20}
          />
        )}
      </G>
    </Svg>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: { flex: 1 }
};
